export default {
  adms: {
    link: {
      create_title: "Establishing link",
      create_ok: "Link",
      create_cancel: "Cancel"
    },
    licenseWarningLink: "<center><red>Please note: This product is not licensed!</red> <companyLink>{{company}}</companyLink> is not responsible for the quality of the software.</center>",
    licenseWarning: "<center><red>Please note: This product is not licensed!</red> The developer is not responsible for the quality of the software.</center>",
    licenseWarningLinkUrl: "https://www.e-projecting.ru/sa",
    companyName: "The developer"
  }
}
